import React, { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import { AccountClient } from '@nile/graphql';
import { GET_REPORT } from '@nile/reports/src/modules/reports/graphql';
import Loading from '@nile/components/src/Svg/AnimatedSvg/Loading.svg';
import { EventEmitter, useCheckFeatureGating } from '@nile/components';
import { EFFICIENCY_REPORTS } from '@nile/reports/src/modules/home/constants';
import EfficiencyReportSheet from './EfficiencyReportSheet';
import CustomReportSheet from './CustomReportSheet';

function EfficiencyReport(props) {
  const { data, setActiveReport, setActiveReportLoading } = props;

  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState({});
  const [client, setClient] = useState(null);
  const isEfficiencyReport = EFFICIENCY_REPORTS.includes(data?.internalName);

  const getFeatureToCheck = () => {
    if (!isEfficiencyReport) {
      return 'CONTRACT_REPORTS';
    }
    return 'EFFICIENCY_REPORTS';
  };

  const featureToCheck = getFeatureToCheck();

  const hasFeatureAccess = useCheckFeatureGating(featureToCheck)?.enabled;

  const getReport = () => {
    setLoading(true);
    AccountClient.query({
      query: GET_REPORT,
      variables: {
        reportId: data?.reportId
      },
      fetchPolicy: 'network-only'
    })
      .then((res) => {
        const result = res?.data?.getReport;
        setActiveReport(result);
        setReportData(result);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
        setActiveReportLoading(false);
      });
  };

  useEffect(() => {
    if (data?.reportId && hasFeatureAccess) {
      getReport();
    }
  }, [JSON.stringify(data)]);

  useEffect(() => {
    if (data?.reportId && hasFeatureAccess) {
      setLoading(true);
      setActiveReportLoading(true);
    }
  }, [data?.reportId]);

  useEffect(() => {
    EventEmitter.subscribe('refreshProfitabilityReport', getReport);
    return () => {
      EventEmitter.unsubscribe('refreshProfitabilityReport');
    };
  }, []);

  if (loading && hasFeatureAccess) {
    return (
      <div className="flex-center full-height">
        <Loading className="w90" />
      </div>
    );
  }

  if (!isEfficiencyReport) {
    return (
      <CustomReportSheet {...data} client={client} setClient={setClient} />
    );
  }
  return !isEmpty(reportData) ? (
    <div className="m10 h95 scroll">
      {Object.values(reportData?.layout?.layout).map((el, ind) => (
        <div
          className="m20 p2040 rounded-4px white-to-grey-bg bshadow"
          key={`layout_${ind}_ind`}
        >
          <EfficiencyReportSheet
            {...el}
            index={ind}
            client={client}
            setClient={setClient}
          />
        </div>
      ))}
    </div>
  ) : (
    <></>
  );
}

export default EfficiencyReport;
